/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { standardizeLocale } from '@jira/platform__supported-locales/src/supported-locales.tsx';
import { IntlProvider } from '@atlassian/jira-intl/src/intl-provider.tsx';
import type { IntlProvidersProps } from './types.tsx';

export const IntlProviders = ({
	children,
	locale,
	messages,
}: IntlProvidersProps): React.JSX.Element => (
	<IntlProvider
		messages={messages}
		locale={standardizeLocale(locale)}
		onError={(err) => {
			// Do not spam local devloop with missing translation errors
			//
			// See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
			// Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
			if (process?.env?.NODE_ENV !== 'production' && err?.code !== 'MISSING_TRANSLATION') {
				// eslint-disable-next-line no-console
				console.error(err);
			}
		}}
	>
		{children}
	</IntlProvider>
);
